var _rect, _path, _path2, _path3, _path4, _path5, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarChartSkeleton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1015,
    height: 386,
    viewBox: "0 0 1015 386",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1014.95,
    height: 386,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2861 286.583H1002.55",
    stroke: "#3C3C3C",
    strokeOpacity: 0.16,
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2861 223H1002.55",
    stroke: "#3C3C3C",
    strokeOpacity: 0.16,
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2861 158.806H1002.55",
    stroke: "#3C3C3C",
    strokeOpacity: 0.16,
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2861 94.6114H1002.55",
    stroke: "#3C3C3C",
    strokeOpacity: 0.16,
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2861 351.389H1002.55",
    stroke: "#3C3C3C",
    strokeOpacity: 0.16,
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.2568,
    y: 21,
    width: 181.291,
    height: 27,
    fill: "#F0F0F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.2568,
    y: 65,
    width: 92.2739,
    height: 14,
    fill: "#F0F0F0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 212,
    width: 46,
    height: 154,
    fill: "#F0F0F0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 175,
    width: 46,
    height: 191,
    fill: "#F0F0F0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 132,
    width: 46,
    height: 234,
    fill: "#F0F0F0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: 195,
    width: 46,
    height: 171,
    fill: "#F0F0F0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 139,
    width: 46,
    height: 227,
    fill: "#F0F0F0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 359,
    y: 175,
    width: 46,
    height: 191,
    fill: "#F0F0F0"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 425,
    y: 223,
    width: 46,
    height: 143,
    fill: "#F0F0F0"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 491,
    y: 121,
    width: 46,
    height: 245,
    fill: "#F0F0F0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 195,
    width: 46,
    height: 171,
    fill: "#F0F0F0"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 623,
    y: 223,
    width: 46,
    height: 143,
    fill: "#F0F0F0"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 689,
    y: 290,
    width: 46,
    height: 76,
    fill: "#F0F0F0"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 755,
    y: 108,
    width: 46,
    height: 258,
    fill: "#F0F0F0"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 821,
    y: 223,
    width: 46,
    height: 143,
    fill: "#F0F0F0"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 887,
    y: 108,
    width: 46,
    height: 258,
    fill: "#F0F0F0"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 953,
    y: 175,
    width: 46,
    height: 191,
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartSkeleton);
export default __webpack_public_path__ + "static/media/BarChartSkeleton.c1daed4c77ea75f7807b3403763f8d8e.svg";
export { ForwardRef as ReactComponent };